import { render } from "./ViewPrivacyPolicy.vue?vue&type=template&id=188da9b0&scoped=true"
import script from "./ViewPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./ViewPrivacyPolicy.vue?vue&type=script&lang=ts"

import "./ViewPrivacyPolicy.vue?vue&type=style&index=0&id=188da9b0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-188da9b0"

export default script